<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox mb-4">
      <div class="row">
        <div class="col-md-2">
          <a class="navbar-brand ml-3" style="font: normal normal normal 16px/25px Poppins">Check TO</a>
        </div>
        <div class="col-md-8">
          <input class="form-control filterInput" type="search" placeholder="Masukkan Nomor TO/NOPOL" aria-label="Search" style="display: flex; font: normal normal normal 16px/25px Poppins" v-model="filter.search" />
        </div>
        <div class="col-md-2 text-right" style="display: flex; justify-content: flex-end">
          <button class="btn" type="button" style="background-color: #1b698e; color: white; padding: 0 50px; height: 100%; font-weight: bold; display: flex; align-items: center; font: normal normal 600 14px/21px Poppins" @click="vue_universal_table.update++">CARI</button>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Body Start -->
    <div class="innerBox">
      <!-- Title & Option Buttons Start -->
      <div class="mb-4 row">
        <div class="col-md-3">
          <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
        </div>
        <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse">
          <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins">Pengecekan Surat Jalan</h3>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <div class="d-flex">
            <div class="col-4" style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins">
              <span style="font: normal normal normal 12px/18px Poppins">Filter Tanggal</span>
            </div>
            <div class="col-8" style="font: normal normal normal 12px/18px Poppins">
              <flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date" style="font: normal normal normal 12px/18px Poppins"></flat-pickr>
            </div>
          </div>
        </div>
      </div>
      <!-- Title & Option Buttons End -->

      <!-- Table Start -->
      <vue-universal-table api_url="/api/validation/cek-to" :filter="filter" :update="vue_universal_table.update" :fields="vue_universal_table.fields" :buttons="vue_universal_table.buttons" :process_data="vue_universal_table.process_data" :infinite_scroll="true" sort_order="DESC" sort_by="tanggal_sj" style="font: normal normal normal 12px/18px Poppins" style_button="true" @onViewDetails="openPengecekanDetails"></vue-universal-table>
      <!-- Table End -->
    </div>
    <!-- Body End -->

    <!-- Modal Start -->
     <new-pengecekan-details v-if="modal.details" :data="modal.data" @closeModal="modal.details = false" @refreshTable="vue_universal_table.update++" />
    <!-- <pengecekan-details v-if="modal.details" :data="modal.data" @closeModal="modal.details = false" @refreshTable="vue_universal_table.update++"></pengecekan-details> -->
    <!-- Modal End -->
  </div>
</template>

<script>
import moment from "moment";
import debounce from "debounce";
import pengecekanDetails from "./children/PengecekanDetails";
import NewPengecekanDetails from "./children/NewPengecekanDetails";
// import { threadId } from 'worker_threads';

export default {
  metaInfo: {
    title: "Pengecekan TO",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      modal: {
        details: null,
        data: {
          no_to: null,
          id: null,
          kode_rute: null,
        },
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr",
      },
      selected: {
        dateButtonsIndex: 2,
        date: `${startDate} to ${currentDate}`,
      },
      filter: {
        start: startDate,
        end: currentDate,
        search: null,
      },
      vue_universal_table: {
        fields: [
          { title: "NO TO", variable: "no_to" },
          { title: "SJ TOTAL", variable: "total_sj" },
          { title: "Unit Total", variable: "total_coly" },
          { title: "TANGGAL SJ", variable: "tanggal_sj" },
          { title: "NOPOL", variable: "nopol" },
          { title: "DRIVER", variable: "driver" },
          { title: "URUTAN TRUK", variable: "no_antrian" },
          { title: "Check Status SJ & Unit", variable: "status_sj2", class: "green", disable_sort: true },
          { title: "Check Status Rute", variable: "status_rute2", disable_sort: true },
        ],
        buttons: [
          {
            title: "viewDetails",
            class: "fas fa-pen btn-outline-primary",
            style: "background-color: #1B698E; color: white;",

            condition: "data.id != 'Belum ada Input'",
          },
        ],
        filter: {},
        update: 0,
        process_data: `
                        for (var i in data) data[i].status_sj2 = data[i].status_sj == 1 ? "✔" : "❌"
                        for (var i in data) data[i].status_rute2 = data[i].status_rute == 1 ? "✔" : "❌"
                    `,
      },
    };
  },
  components: {
    pengecekanDetails,
    NewPengecekanDetails
  },
  mounted() {},
  watch: {
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];

      //Check End
      if (this.filter.end != moment().format("YYYY-MM-DD")) {
        this.selected.dateButtonsIndex = -1;
        //Check Start
      } else if (this.options.dateButtons.map((x) => x.start).indexOf(this.rangePickr.start) == -1) {
        this.selected.dateButtonsIndex = -1;
        //Found Match
      } else {
        this.selected.dateButtonsIndex = this.options.dateButtons.map((x) => x.start).indexOf(this.rangePickr.start);
      }

      this.vue_universal_table.update++;
      this.modal.edit = false;
      this.modal.new = false;
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
    filter: {
      deep: true,
      handler: "emitFilter",
    },
  },
  methods: {
    openPengecekanDetails(data) {
      data = JSON.parse(data);
      // this.modal.data.id = data.id.replace(/"/g, '');
      // this.modal.data.nopol = data.nopol;
      this.modal.details = true;
      this.modal.data = data;
    },
    selectDateButton(i) {
      this.selected.date = `${this.options.dateButtons[i].start} to ${this.options.dateButtons[i].end}`;
      this.selected.dateButtonsIndex = i;
    },
    debouncelessEmitFilter() {
      this.$emit("filterChange", this.vue_universal_table.update++);
    },
    emitFilter: debounce(function () {
      this.$emit("filterChange", this.vue_universal_table.update++);
    }, 1500),
  },
};
</script>

<style>
.green {
  color: green;
}
</style>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.tableTitle {
  text-align: center;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}
</style>
